import { render, staticRenderFns } from "./TimeEventCards.vue?vue&type=template&id=54b00c34&scoped=true"
import script from "./TimeEventCards.vue?vue&type=script&lang=ts"
export * from "./TimeEventCards.vue?vue&type=script&lang=ts"
import style0 from "./TimeEventCards.vue?vue&type=style&index=0&id=54b00c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b00c34",
  null
  
)

export default component.exports